import { CancelToken } from 'axios'
import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

export const deleteTitleOutputService = (
  reportId: string,
  inputId: string,
  outputId: string,
  cancelToken?: CancelToken,
) =>
  apiInstance.delete(
    ApiPathConfig.TITLE_OUTPUT_BY_ID(reportId, inputId, outputId),
    {
      cancelToken,
    },
  )
